import React from 'react';
import { motion } from 'framer-motion';
import { valueItems } from '../data/benefits';
export function EducatorValues() {
  return <section className="py-24 px-4 bg-stone-50" data-id="element-79" data-mp="2w1ae1u3mlq7d">
      <div className="max-w-6xl mx-auto" data-id="element-80" data-mp="2h4s041454s4k">
        <div className="text-center mb-16" data-id="element-81" data-mp="2h3qdczdrih70">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-stone-800" data-id="element-82" data-mp="2m3mi50uaacnm">
            What Makeup Educators Value Most
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-6" data-id="element-83" data-mp="28an473a5gqi6">
          {valueItems.map((item, i) => {
          const Icon = item.icon;
          return <motion.article key={item.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i % 3 * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className={`bg-white border border-stone-200 p-8 rounded-2xl flex flex-col h-full lg:col-span-2 ${i === 3 ? 'lg:col-start-2' : ''} ${i === valueItems.length - 1 ? 'md:col-span-2 lg:col-span-2' : ''}`} data-id="element-84" data-mp="1yetiouegdmo9" data-mpi={i}>
                <div className="w-12 h-12 rounded-full bg-rose-700 text-white flex items-center justify-center shrink-0 mb-6" data-id="element-85" data-mp="1f83vcr5ol2dm">
                  <Icon size={22} aria-hidden="true" data-id="element-86" data-mp="mioehkrc4f9s" />
                </div>
                <h3 className="font-sans font-bold text-sm uppercase tracking-wider text-rose-800 mb-3" data-id="element-87" data-mp="mgk5ioekwq2n">
                  {item.title}
                </h3>
                <p className="text-stone-600 leading-relaxed" data-id="element-88" data-mp="wft6403y92xz">{item.text}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}